import { AppCard } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { VendorUserTabDetails } from "./-internal_components/VendorUserTabDetails";
import { Route as VendorRoute } from "./route";

const RouteComponent: React.FC = () => {
  const vendor = VendorRoute.useLoaderData();

  return (
    <AppCard>
      <VendorUserTabDetails vendor={vendor} />
    </AppCard>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendor/users",
)({
  component: RouteComponent,
});
